// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__gcfUv","formPage":"LoginPage_formPage__Zv3za"};